import { Link } from "react-router-dom";
import React from "react";
import visualState from "../../../visualState";
import Context from "../../../Context";

import EssenceReference from "../../Essence/EssenceReference";
import EssenceReferenceCalendarEdit from "../../Essence/EssenceReferenceCalendarEdit";
import EssenceReferenceSchedulerEdit from "../../Essence/EssenceReferenceSchedulerEdit";
import EssenceReferencePositionEdit from "../../Essence/EssenceReferencePositionEdit";
import EssenceReferenceShipEdit from "../../Essence/EssenceReferenceShipEdit";
import EssenceReferenceStorageEdit from "../../Essence/EssenceReferenceStorageEdit";
import EssenceReferenceCisternEdit from "../../Essence/EssenceReferenceCisternEdit";

import SVGGroup1 from "../../Misc/SvgIcons/SVGGroup1";
import SVGComponent1 from "../../Misc/SvgIcons/SVGComponent1";
import SVGLayout1 from "../../Misc/SvgIcons/SVGLayout1";
import SVGShirt1 from "../../Misc/SvgIcons/SVGShirt1";
import SVGDial1 from "../../Misc/SvgIcons/SVGDial1";
import SVGClock1 from "../../Misc/SvgIcons/SVGClock1";
import SVGCommode1 from "../../Misc/SvgIcons/SVGCommode1";
import EssenceFiles from "../../Essence/EssenceFiles";
import SVGUrgentMail from "../../Misc/SvgIcons/SVGUrgentMail";
import SVGScheme1 from "../../Misc/SvgIcons/SVGScheme1";
import SVGBezier1 from "../../Misc/SvgIcons/SVGBezier1";
import SVGPuzzle1 from "../../Misc/SvgIcons/SVGPuzzle1";
import SVGShip1 from "../../Misc/SvgIcons/SVGShip1";
import SVGSteering1 from "../../Misc/SvgIcons/SVGSteering1";
import SVGRuller1 from "../../Misc/SvgIcons/SVGRuller1";
import SVGList1 from "../../Misc/SvgIcons/SVGList1";
import SVGStorage from "../../Misc/SvgIcons/SVGStorage";
import SVGCurrency1 from "../../Misc/SvgIcons/SVGCurrency1";
import SVGScheme2 from "../../Misc/SvgIcons/SVGScheme2";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import SVGOil from "../../Misc/SvgIcons/SVGOil";
import SVGDock from "../../Misc/SvgIcons/SVGDock";
import SVGList from "../../Misc/SvgIcons/SVGList";
import SVGTank from "../../Misc/SvgIcons/SVGTank";
import ReferenceTabs from "./ReferenceTabs";
import SVGProcedure1 from "../../Misc/SvgIcons/SVGProcedure1";
import SVGInput1 from "../../Misc/SvgIcons/SVGInput1";
import EssenceReferenceReportRoutineEdit from "../../Essence/EssenceReferenceReportRoutineEdit";
import EssenceReferenceReportFormEdit from "../../Essence/EssenceReferenceReportFormEdit";
import EssenceReferenceReportEdit from "../../Essence/EssenceReferenceReportEdit";
import SVGFlag2 from "../../Misc/SvgIcons/SVGFlag2";
import SVGLegal from "../../Misc/SvgIcons/SVGLegal";
import EssenceReferenceLegalEdit from "../../Essence/EssenceReferenceLegalEdit";
import EssenceReferenceJournalEdit from "../../Essence/EssenceReferenceJournalEdit";
import SVGJournal from "../../Misc/SvgIcons/SVGJournal";
import SVGJournalDown from "../../Misc/SvgIcons/SVGJournalDown";
import SVGJournalCode from "../../Misc/SvgIcons/SVGJournalCode";
import EssenceReferenceFormEdit from "../../Essence/EssenceReferenceFormEdit";
import EssenceReferenceCountryEdit from "../../Essence/EssenceReferenceCountryEdit";
import SVGStructure2 from "../../Misc/SvgIcons/SVGStructure2";
import SVGNuts from "../../Misc/SvgIcons/SVGNuts";
import SVGBlueprint from "../../Misc/SvgIcons/SVGBlueprint";
import SVGFactory from "../../Misc/SvgIcons/SVGFactory";
import Searchbox from "../../Misc/Searchbox";
import SVGWrenchDoc from "../../Misc/SvgIcons/SVGWrenchDoc";

export default class Reference extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.vState = new visualState("ReferenceSection");
    this.state = {
      search: "",
      searchRef: React.createRef(),
      tabs: {
        documentation: {
          visible: true,
          label: "Документация",
          items: [
            "ism.structure",
            "activity",
            "library",
            "techdoc",
            "emergency_folder",
          ],
        },
        organisation: {
          visible: true,
          label: "Структура организации",
          items: ["soc.structure", "staff", "position", "contractor"],
        },
        tech: {
          visible: true,
          label: "Суда и компоненты",
          items: [
            "maintenance.structure",
            "vendor",
            "category",
            "specification",
            "repair.structure",
            "project",
            "ship",
            "model",
            "storage",
            "cistern",
          ],
        },
        rprts: {
          visible: true,
          label: "Отчеты",
          items: ["report_tree", "report", "report_form", "report_routine"],
        },
        journ: {
          visible: true,
          label: "Журналы",
          items: ["journal_tree", "journal", "form"],
        },
        misc: {
          visible: true,
          label: "Прочее",
          items: [
            "calendar",
            "scheduler",
            "form",
            "measure",
            "country",
            "currency",
            "property",
            "harbor",
          ],
        },
      },
      show: {},
      asList: this.vState.read("asList", false),
    };
  }
  toggleReference = (reference) => {
    this.setState((state) => {
      let show = state.show;
      show[reference] = show[reference] ? false : true;
      return { show };
    });
  };

  isAccessible = (essence, ignoreTab = false) => {
    if (this.context.user.isAdmin) return true;
    let className = essence;
    if (essence.includes(".")) {
      className = essence.split(".").pop();
    }
    let access = this.context.user.classAccess[className] || {};
    if (access.c || access.u || access.d) {
      return true;
    }
    return false;
  };

  toggleList = () => {
    this.setState((state) => {
      this.vState.save({ asList: !state.asList });
      return { asList: !state.asList };
    });
  };

  componentDidMount() {
    if (this.state.searchRef.current) {
      this.state.searchRef.current.focus();
    }
    this.renderButtons();
  }

  componentDidUpdate() {
    this.renderButtons();
  }

  renderButtons = () => {
    this.context.actionsSet(
      <>
        <button
          title="Отображение списка"
          onClick={this.toggleList}
          className={`btn btn-icon ${
            this.state.asList
              ? "bg-light-primary bg-hover-light"
              : "bg-light bg-hover-light-primary"
          }    mr-2`}
        >
          <i
            className={`fa fa-th-list ${
              this.state.asList ? "text-primary" : "text-muted"
            } `}
          ></i>
        </button>
      </>
    );
  };

  render() {
    const { asList, search } = this.state;
    const { tabId } = this.props;

    const tiles = {
      "ism.structure": {
        searchable: "Структура документации",
        render: (
          <>
            <EssenceReference
              essence="structure"
              sort="sequence"
              draggable
              title="Структура документации"
              showDescription
              structure
              editOnDblClick
              show={this.state.show["ism.structure"]}
              onHide={() => this.toggleReference("ism.structure")}
              forceType="ism.structure"
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("ism.structure")}
                className={`card cursor-pointer card-custom card-stretch gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span
                    className={`svg-icon svg-icon-warning svg-icon-3x ml-n1`}
                  >
                    <SVGLayout1 />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Структура документации
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Создание и настройка <br />
                    структуры документации.
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      "soc.structure": {
        searchable: "Структура организации должность отдел",
        render: (
          <>
            <EssenceReference
              essence="structure"
              sort="sequence"
              draggable
              title="Структура организации"
              showDescription
              structure
              editOnDblClick
              show={this.state.show["soc.structure"]}
              onHide={() => this.toggleReference("soc.structure")}
              forceType="soc.structure"
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("soc.structure")}
                className={`card cursor-pointer card-custom card-stretch gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span
                    className={`svg-icon svg-icon-warning svg-icon-3x ml-n1`}
                  >
                    <SVGStructure2 />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Структура организации
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Создание и настройка <br />
                    структуры организации.
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      activity: {
        searchable: "Схемы согласования",
        render: (
          <>
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <Link to="/scheme/">
                <div
                  className={`card cursor-pointer card-custom card-stretch gutter-b bg-hover-light`}
                >
                  <div className="card-body">
                    <span
                      className={`svg-icon svg-icon-warning svg-icon-3x ml-n1`}
                    >
                      <SVGScheme2 />
                    </span>
                    <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                      Схемы согласования
                    </div>
                    <div className="font-weight-bold text-inverse-white font-size-sm">
                      Настройка схем согласования документов
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </>
        ),
      },
      staff: {
        searchable: "Сотрудники должность",
        render: (
          <>
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <Link to="/staff/">
                <div
                  className={`card cursor-pointer card-custom card-stretch gutter-b bg-hover-light`}
                >
                  <div className="card-body">
                    <span
                      className={`svg-icon svg-icon-primary svg-icon-3x ml-n1`}
                    >
                      <SVGGroup1 />
                    </span>
                    <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                      Сотрудники
                    </div>
                    <div className="font-weight-bold text-inverse-white font-size-sm">
                      Интерфейс управления сотрудниками
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </>
        ),
      },
      position: {
        searchable: "Должности",
        render: (
          <>
            <EssenceReference
              essence="position"
              title="Должности"
              showDescription
              showType
              editOnDblClick
              show={this.state.show["position"]}
              onHide={() => this.toggleReference("position")}
              itemEditor={(itemEditorProps) => (
                <EssenceReferencePositionEdit {...itemEditorProps} />
              )}
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("position")}
                className={`card cursor-pointer card-custom card-stretch gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span
                    className={`svg-icon svg-icon-primary svg-icon-3x ml-n1`}
                  >
                    <SVGShirt1 />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Должности
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Справочник должностей для <br />
                    назначения сотрудникам
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      contractor: {
        searchable: "Контрагенты",
        render: (
          <>
            <EssenceReference
              essence="contractor"
              title="Контрагенты"
              showType
              showDescription
              editOnDblClick
              show={this.state.show["contractor"]}
              onHide={() => this.toggleReference("contractor")}
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("contractor")}
                className={`card cursor-pointer card-custom card-stretch gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span className={`svg-icon svg-icon-info svg-icon-3x ml-n1`}>
                    <SVGLegal />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Контрагенты
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Справочник контрагентов и
                    <br />
                    юридических лиц
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      calendar: {
        searchable: "Календари",
        render: (
          <>
            <EssenceReference
              essence="calendar"
              title="Календари"
              showDescription
              showType
              editOnDblClick
              show={this.state.show["calendar"]}
              onHide={() => this.toggleReference("calendar")}
              itemEditor={(itemEditorProps) => (
                <EssenceReferenceCalendarEdit {...itemEditorProps} />
              )}
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("calendar")}
                className={`card cursor-pointer card-custom card-stretch   gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span
                    className={`svg-icon svg-icon-success svg-icon-3x ml-n1`}
                  >
                    <SVGDial1 />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Календари
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Управление
                    <br />
                    календарями
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      scheduler: {
        searchable: "Расписания планировщик",
        render: (
          <>
            <EssenceReference
              essence="scheduler"
              title="Расписания"
              showDescription
              showType
              editOnDblClick
              show={this.state.show["scheduler"]}
              onHide={() => this.toggleReference("scheduler")}
              itemEditor={(itemEditorProps) => (
                <EssenceReferenceSchedulerEdit {...itemEditorProps} />
              )}
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("scheduler")}
                className={`card cursor-pointer card-custom card-stretch   gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span
                    className={`svg-icon svg-icon-success svg-icon-3x ml-n1`}
                  >
                    <SVGClock1 />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Расписания
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Наборы расписаниий для различных задач
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      library: {
        searchable: "Библиотека",
        render: (
          <>
            <EssenceReference
              essence="library"
              sort="sequence"
              draggable
              title="Библиотека"
              showDescription
              hideCode
              structure
              editOnDblClick
              show={this.state.show["library"]}
              onHide={() => this.toggleReference("library")}
              itemEditor={(itemEditorProps) => (
                <EssenceFiles {...itemEditorProps} />
              )}
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("library")}
                className={`card cursor-pointer card-custom card-stretch   gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span className={`svg-icon svg-icon-info svg-icon-3x ml-n1`}>
                    <SVGCommode1 />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Библиотека
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Настройка и наполнение
                    <br />
                    библиотеки
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      techdoc: {
        searchable: "Техническая документация",
        render: (
          <>
            <EssenceReference
              essence="techdoc"
              sort="sequence"
              draggable
              title="Техническая документация"
              showDescription
              hideCode
              structure
              editOnDblClick
              show={this.state.show["techdoc"]}
              onHide={() => this.toggleReference("techdoc")}
              itemEditor={(itemEditorProps) => (
                <EssenceFiles {...itemEditorProps} />
              )}
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("techdoc")}
                className={`card cursor-pointer card-custom card-stretch   gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span className={`svg-icon svg-icon-info svg-icon-3x ml-n1`}>
                    <SVGWrenchDoc />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Техническая документация
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Библиотека технической
                    <br />
                    документации
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      emergency_folder: {
        searchable: "Аварийная папка",
        render: (
          <>
            <EssenceReference
              essence="emergency_folder"
              sort="sequence"
              draggable
              title="Аварийная папка"
              showDescription
              structure
              hideCode
              editOnDblClick
              nameField="label"
              show={this.state.show["emergency_folder"]}
              onHide={() => this.toggleReference("emergency_folder")}
              itemEditor={(itemEditorProps) => (
                <EssenceFiles {...itemEditorProps} />
              )}
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("emergency_folder")}
                className={`card cursor-pointer card-custom card-stretch   gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span className={`svg-icon svg-icon-info svg-icon-3x ml-n1`}>
                    <SVGUrgentMail />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Аварийная папка
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Настройка и наполнение
                    <br />
                    аварийной папки
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      measure: {
        searchable: "Мера единицы измерения",
        render: (
          <>
            <EssenceReference
              essence="measure"
              title="Единицы измерения"
              showDescription
              showType
              editOnDblClick
              show={this.state.show["measure"]}
              onHide={() => this.toggleReference("measure")}
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("measure")}
                className={`card cursor-pointer card-custom card-stretch   gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span
                    className={`svg-icon svg-icon-success svg-icon-3x ml-n1`}
                  >
                    <SVGRuller1 />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Измерения
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Перечень единиц
                    <br />
                    измерений
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      country: {
        searchable: "Страны государства",
        render: (
          <>
            <EssenceReference
              essence="country"
              title="Страны"
              showDescription
              editOnDblClick
              show={this.state.show["country"]}
              onHide={() => this.toggleReference("country")}
              itemEditor={(itemEditorProps) => (
                <EssenceReferenceCountryEdit {...itemEditorProps} />
              )}
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("country")}
                className={`card cursor-pointer card-custom card-stretch   gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span
                    className={`svg-icon svg-icon-warning svg-icon-3x ml-n1`}
                  >
                    <SVGFlag2 />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Страны
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Справочник стран
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      currency: {
        searchable: "Валюты",
        render: (
          <>
            <EssenceReference
              essence="currency"
              title="Валюты"
              showDescription
              showType
              editOnDblClick
              show={this.state.show["currency"]}
              onHide={() => this.toggleReference("currency")}
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("currency")}
                className={`card cursor-pointer card-custom card-stretch   gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span
                    className={`svg-icon svg-icon-success svg-icon-3x ml-n1`}
                  >
                    <SVGCurrency1 />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Валюты
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Справочник валют
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      property: {
        searchable: "Свойства",
        render: (
          <>
            <EssenceReference
              essence="property"
              sort="sequence"
              title="Свойства"
              showDescription
              editOnDblClick
              show={this.state.show["property"]}
              onHide={() => this.toggleReference("property")}
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("property")}
                className={`card cursor-pointer card-custom card-stretch   gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span
                    className={`svg-icon svg-icon-success svg-icon-3x ml-n1`}
                  >
                    <SVGList1 />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Свойства
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Все свойства
                    <br />
                    доступные в системе
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      project: {
        searchable: "Проекты cудна суда",
        render: (
          <>
            <EssenceReference
              essence="project"
              sort="sequence"
              title="Проекты судов"
              showDescription
              editOnDblClick
              show={this.state.show["project"]}
              onHide={() => this.toggleReference("project")}
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("project")}
                className={`card cursor-pointer card-custom card-stretch   gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span
                    className={`svg-icon svg-icon-primary svg-icon-3x ml-n1`}
                  >
                    <SVGBlueprint />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Проекты
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Досутпные проекты
                    <br />
                    судов
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      ship: {
        searchable: "Суда судно",
        render: (
          <>
            <EssenceReference
              essence="ship"
              sort="sequence"
              title="Суда"
              codeLabel="IMO"
              showDescription
              editOnDblClick
              show={this.state.show["ship"]}
              onHide={() => this.toggleReference("ship")}
              extraFields={["projectname"]}
              itemEditor={(itemEditorProps) => (
                <EssenceReferenceShipEdit {...itemEditorProps} />
              )}
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("ship")}
                className={`card cursor-pointer card-custom card-stretch   gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span
                    className={`svg-icon svg-icon-primary svg-icon-3x ml-n1`}
                  >
                    <SVGShip1 />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Суда
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Список судов
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      cistern: {
        searchable: "Бункер цистерны",
        render: (
          <>
            <EssenceReference
              essence="cistern"
              sort="sequence"
              title="Бункеры"
              showDescription
              editOnDblClick
              show={this.state.show["cistern"]}
              onHide={() => this.toggleReference("cistern")}
              itemEditor={(itemEditorProps) => (
                <EssenceReferenceCisternEdit {...itemEditorProps} />
              )}
              extraFields={["shipname"]}
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("cistern")}
                className={`card cursor-pointer card-custom card-stretch   gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span className={`svg-icon svg-icon-info svg-icon-3x ml-n1`}>
                    <SVGTank />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Бункеры
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Справочник судовых бункеров
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      vendor: {
        searchable: "Производители",
        render: (
          <>
            <EssenceReference
              essence="vendor"
              sort="sequence"
              title="Производитель"
              showDescription
              editOnDblClick
              show={this.state.show["vendor"]}
              onHide={() => this.toggleReference("vendor")}
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("vendor")}
                className={`card cursor-pointer card-custom card-stretch   gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span
                    className={`svg-icon svg-icon-primary svg-icon-3x ml-n1`}
                  >
                    <SVGFactory />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Производитель
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Управление
                    <br />
                    производятелями
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      category: {
        searchable: "Категория каталог",
        render: (
          <>
            <EssenceReference
              essence="category"
              sort="sequence"
              title="Категория"
              showDescription
              editOnDblClick
              show={this.state.show["category"]}
              onHide={() => this.toggleReference("category")}
              forceType="item.category"
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("category")}
                className={`card cursor-pointer card-custom card-stretch   gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span
                    className={`svg-icon svg-icon-primary svg-icon-3x ml-n1`}
                  >
                    <SVGComponent1 />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Категория
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Категории оборудования для
                    <br />
                    каталога технического менеджмента
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      specification: {
        searchable: "Спецификация структура судовые",
        render: (
          <>
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <Link to="/spec/">
                <div
                  className={`card cursor-pointer card-custom card-stretch gutter-b bg-hover-light`}
                >
                  <div className="card-body">
                    <span
                      className={`svg-icon svg-icon-primary svg-icon-3x ml-n1`}
                    >
                      <SVGNuts />
                    </span>
                    <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                      Спецификация
                    </div>
                    <div className="font-weight-bold text-inverse-white font-size-sm">
                      Структура каталога оборудования
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </>
        ),
      },
      "maintenance.structure": {
        searchable: "виды типы ТО технического обслуживания",
        render: (
          <>
            <EssenceReference
              essence="structure"
              sort="sequence"
              draggable
              title="Виды и типы ТО"
              showDescription
              structure
              editOnDblClick
              show={this.state.show["maintenance.structure"]}
              onHide={() => this.toggleReference("maintenance.structure")}
              forceType="maintenance.structure"
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("maintenance.structure")}
                className={`card cursor-pointer card-custom card-stretch gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span
                    className={`svg-icon svg-icon-warning svg-icon-3x ml-n1`}
                  >
                    <SVGOil />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Виды и типы ТО
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Структура технического обслуживания
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      "repair.structure": {
        searchable: "Ремонтные работы виды типы",
        render: (
          <>
            <EssenceReference
              essence="structure"
              sort="sequence"
              draggable
              title="Виды и типы работ"
              showDescription
              structure
              editOnDblClick
              show={this.state.show["repair.structure"]}
              onHide={() => this.toggleReference("repair.structure")}
              forceType="repair.structure"
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("repair.structure")}
                className={`card cursor-pointer card-custom card-stretch gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span
                    className={`svg-icon svg-icon-warning svg-icon-3x ml-n1`}
                  >
                    <SVGList />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Виды и типы работ
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Работы в ремонтных ведомостях
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      model: {
        searchable: "Модели ЗИП",
        render: (
          <>
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <Link to="/model/">
                <div
                  className={`card cursor-pointer card-custom card-stretch gutter-b bg-hover-light`}
                >
                  <div className="card-body">
                    <span
                      className={`svg-icon svg-icon-success svg-icon-3x ml-n1`}
                    >
                      <SVGPuzzle1 />
                    </span>
                    <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                      ЗИП
                    </div>
                    <div className="font-weight-bold text-inverse-white font-size-sm">
                      Интерфейс перечня запчастей и оборудования
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </>
        ),
      },
      storage: {
        searchable: "Склады места хранения запасов",
        render: (
          <>
            <EssenceReference
              essence="storage"
              sort="sequence"
              title="Места хранения"
              showDescription
              editOnDblClick
              show={this.state.show["storage"]}
              onHide={() => this.toggleReference("storage")}
              itemEditor={(itemEditorProps) => (
                <EssenceReferenceStorageEdit {...itemEditorProps} />
              )}
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("storage")}
                className={`card cursor-pointer card-custom card-stretch   gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span className={`svg-icon svg-icon-info svg-icon-3x ml-n1`}>
                    <SVGStorage />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Места хранения
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Перечень мест хранения
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      harbor: {
        searchable: "Порты",
        render: (
          <>
            <EssenceReference
              essence="harbor"
              sort="sequence"
              title="Порты"
              showDescription
              editOnDblClick
              show={this.state.show["harbor"]}
              onHide={() => this.toggleReference("harbor")}
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("harbor")}
                className={`card cursor-pointer card-custom card-stretch   gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span
                    className={`svg-icon svg-icon-warning svg-icon-3x ml-n1`}
                  >
                    <SVGDock />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Порты
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Справочник портов
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      report_tree: {
        searchable: "Структура отчетов",
        render: (
          <>
            <EssenceReference
              accessEssence="report_tree"
              essence="report/tree"
              sort="sequence"
              draggable
              title="Структура отчетов"
              showDescription
              structure
              editOnDblClick
              show={this.state.show["report_tree"]}
              onHide={() => this.toggleReference("report_tree")}
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("report_tree")}
                className={`card cursor-pointer card-custom card-stretch gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span
                    className={`svg-icon svg-icon-warning svg-icon-3x ml-n1`}
                  >
                    <SVGScheme1 />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Структура отчетов
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Создание и настройка <br />
                    дерева отчетов.
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      report: {
        searchable: "Отчеты",
        render: (
          <>
            <EssenceReference
              essence="report"
              sort="sequence"
              title="Список отчетов"
              showDescription
              editOnDblClick
              show={this.state.show["report"]}
              onHide={() => this.toggleReference("report")}
              itemEditor={(itemEditorProps) => (
                <EssenceReferenceReportEdit {...itemEditorProps} />
              )}
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("report")}
                className={`card cursor-pointer card-custom card-stretch   gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span
                    className={`svg-icon svg-icon-primary svg-icon-3x ml-n1`}
                  >
                    <SVGInput1 />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Список отчетов
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Полный список отчетов
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      report_form: {
        searchable: "Формы отчетов",
        render: (
          <>
            <EssenceReference
              accessEssence="report_form"
              essence="report/form"
              sort="sequence"
              title="Формы отчетов"
              showDescription
              extraFields={["definition"]}
              editOnDblClick
              show={this.state.show["report_form"]}
              onHide={() => this.toggleReference("report_form")}
              itemEditor={(itemEditorProps) => (
                <EssenceReferenceReportFormEdit {...itemEditorProps} />
              )}
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("report_form")}
                className={`card cursor-pointer card-custom card-stretch   gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span
                    className={`svg-icon svg-icon-success svg-icon-3x ml-n1`}
                  >
                    <SVGList />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Формы отчетов
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Перечень форм данных отчетов
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      report_routine: {
        searchable: "Функции отчетов",
        render: (
          <>
            <EssenceReference
              accessEssence="report_routine"
              essence="report/routine"
              sort="sequence"
              title="Функции отчетов"
              showDescription
              extraFields={["definition"]}
              editOnDblClick
              show={this.state.show["report_routine"]}
              onHide={() => this.toggleReference("report_routine")}
              itemEditor={(itemEditorProps) => (
                <EssenceReferenceReportRoutineEdit {...itemEditorProps} />
              )}
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("report_routine")}
                className={`card cursor-pointer card-custom card-stretch   gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span
                    className={`svg-icon svg-icon-success svg-icon-3x ml-n1`}
                  >
                    <SVGProcedure1 />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Функции отчетов
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Перечень доступных функций отчетов
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      journal_tree: {
        searchable: "",
        render: (
          <>
            <EssenceReference
              accessEssence="journal"
              essence="journal/tree"
              sort="sequence"
              draggable
              title="Структура журналов"
              showDescription
              structure
              editOnDblClick
              show={this.state.show["journal_tree"]}
              onHide={() => this.toggleReference("journal_tree")}
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("journal_tree")}
                className={`card cursor-pointer card-custom card-stretch gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span
                    className={`svg-icon svg-icon-warning svg-icon-3x ml-n1`}
                  >
                    <SVGJournalDown />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Структура журналов
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Настройка структуры и<br />
                    дерева журналов.
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      form: {
        searchable: "Формы",
        render: (
          <>
            <EssenceReference
              accessEssence="form"
              essence="form"
              sort="sequence"
              title="Формы"
              showDescription
              editOnDblClick
              show={this.state.show["form"]}
              onHide={() => this.toggleReference("form")}
              itemEditor={(itemEditorProps) => (
                <EssenceReferenceFormEdit {...itemEditorProps} />
              )}
              showType
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("form")}
                className={`card cursor-pointer card-custom card-stretch   gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span
                    className={`svg-icon svg-icon-success svg-icon-3x ml-n1`}
                  >
                    <SVGJournalCode />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Формы
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Настройка форм документов и журналов
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
      journal: {
        searchable: "Журналы",
        render: (
          <>
            <EssenceReference
              essence="journal"
              sort="sequence"
              title="Список журналов"
              showDescription
              editOnDblClick
              nameField="label"
              show={this.state.show["journal"]}
              onHide={() => this.toggleReference("journal")}
              itemEditor={(itemEditorProps) => (
                <EssenceReferenceJournalEdit {...itemEditorProps} />
              )}
            />
            <div className={`${asList ? "reference-holder" : "col-lg-4"}`}>
              <div
                onClick={() => this.toggleReference("journal")}
                className={`card cursor-pointer card-custom card-stretch   gutter-b bg-hover-light`}
              >
                <div className="card-body">
                  <span className={`svg-icon svg-icon-info svg-icon-3x ml-n1`}>
                    <SVGJournal />
                  </span>
                  <div className="text-inverse-white font-weight-bolder font-size-h5 mb-2 mt-5">
                    Список журналов
                  </div>
                  <div className="font-weight-bold text-inverse-white font-size-sm">
                    Настройка журналов
                  </div>
                </div>
              </div>
            </div>
          </>
        ),
      },
    };

    return (
      <>
        <CrumbsProvider title="Параметры" link="/reference/" />
        <div className="container">
          <div className="mb-3">
            <Searchbox
              onSearch={(search) => this.setState({ search })}
              inputRef={this.state.searchRef}
              immediate
            />
          </div>
          <ReferenceTabs
            tabs={this.state.tabs}
            tabId={this.props.tabId}
            isAccessible={this.isAccessible}
          />
          <div className="row">
            {Object.keys(tiles).map((k) => {
              if (search) {
                let searchReg = new RegExp(
                  this.context.api.regexEscape(search),
                  "i"
                );
                if (tiles[k].searchable.search(searchReg) <= -1) {
                  return null;
                }
              }
              if (tabId && !search) {
                let tab = this.state.tabs[tabId] || {};
                if (tab.items) {
                  if (!tab.items.includes(k)) {
                    return null;
                  }
                }
              }

              if (this.isAccessible(k)) {
                return (
                  <React.Fragment key={k}>{tiles[k].render}</React.Fragment>
                );
              }
              return null;
            })}
          </div>
        </div>
      </>
    );
  }
}
